import { mmsStore } from '../app/app.config';
// import { AppState } from '../app/app.types';
import { IdleState } from '../idle/Types';
import { FIFTY_NINE_TIMEOUT_MILLIS } from '../idle/Constants';

export const isAuthTokenExpired = (): boolean => {
  const idleState: IdleState = (mmsStore.getState() as any).idleState;

  return (new Date().getTime() - idleState.tokenLastUsedTime) > FIFTY_NINE_TIMEOUT_MILLIS;
};



// WEBPACK FOOTER //
// ./src/commons/AuthTokenValidator.tsx